import React from "react";
import PropTypes from "prop-types";
import { MenuItem } from "react-contextmenu";
import { Icon } from "rhombus-react";
import { Link } from "react-router-dom";
export default function LinkAction(props){
	let { name, path, useMenuItem,
			className, iconName, iconClass, iconStyle,
			isDisabled, tooltipContent, isMultiLine } = props

		, iconProps = {
			name:iconName,
			className:iconClass,
			iconStyle,
	 	}
		, disabledClass = isDisabled ? "is-disabled" : ""
		;

	let $content = (
		<div className={`action-item ${className}`} data-multiline={isMultiLine} data-tip={tooltipContent} >
			<Link to={path} className={`${disabledClass}`} >
				<span className="action-icon" >
					<Icon {...iconProps} />
				</span>
				{name?(<span className="action-name">{name}</span>):null}
			</Link>
		</div>
	);

	if(useMenuItem){
		return <MenuItem >{$content}</MenuItem>;
	}

	return $content;
}

LinkAction.displayName = "LinkAction";
LinkAction.defaultProps = {
	title:"",
	iconName:"",
	name:"",
	path:"",
	useMenuItem:true,
	className:"",
	iconClass:"",
	iconStyle:undefined,
	isDisabled:false,
};

LinkAction.propTypes ={
	title: PropTypes.string,
	iconName: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	path: PropTypes.string,
	useMenuItem:PropTypes.bool,
	className:PropTypes.string,
	iconClass:PropTypes.string,
	iconStyle:PropTypes.string,
	isDisabled:PropTypes.bool,
};
